import { Component, OnInit } from '@angular/core';
import { ActivatedRoute }             from '@angular/router';

import { SubscriptionsService }       from './subscriptions.service';
import { SubscriptionInvoice }           from './models/subscription-invoice';

@Component({
  selector: 'app-subscription-invoices',
  templateUrl: './subscription-invoices.component.html',
  styleUrls: ['./subscription-invoices.component.less']
})
export class SubscriptionInvoicesComponent implements OnInit {
  public invoices: SubscriptionInvoice[] = null;

  constructor(private api: SubscriptionsService, private route: ActivatedRoute) {
    this.route.parent.params.subscribe(params => {
      let subscriptionId = params['id'];
      this.api.getSubscriptionInvoices(subscriptionId).subscribe(invoices => this.invoices = invoices);
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-invoices.component.ts